import { render, staticRenderFns } from "./SaleAlertNotification.vue?vue&type=template&id=7db21168&scoped=true"
import script from "./SaleAlertNotification.vue?vue&type=script&lang=js"
export * from "./SaleAlertNotification.vue?vue&type=script&lang=js"
import style0 from "./SaleAlertNotification.vue?vue&type=style&index=0&id=7db21168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db21168",
  null
  
)

export default component.exports